
import './App.css';

import Footernya from './Komponen/Footer/Footernya';
import Navbarnya from './Komponen/Navbarnya/Navbarnya';

import Bodynya from './Komponen/Bodynya/Bodynya';

function App() {
  return (
    <div className="App">
      <Navbarnya/>
      
      <Bodynya/>

      <Footernya/>
    </div>
  );
}

export default App;
